'use client';

import { IconButton } from '@coolblue-development/freddy';
import { Cross } from '@coolblue-development/icons';
import { FilterPageContext } from '@features/filter/context';
import { useTranslation } from '@i18n/useTranslation';
import { useContext } from 'react';

export const FilterRemover = ({
  displayValue,
  filterIdentifier
}: {
  displayValue: string;
  filterIdentifier: string;
}) => {
  const { setFilter } = useContext(FilterPageContext);
  const { t } = useTranslation('webshop.filterPage.selectedFilters');
  const ariaLabelText = t('removeFilter', { filterName: displayValue });

  function handleClick() {
    // comibinedBooleanFilters return multiple values
    // as a comma delimited string. to accomodate all values
    // we split just in case, since setFilter allows an array of values
    const filterIdentifiers = filterIdentifier.split(',');
    const filterValues = filterIdentifiers.map(filter => ({
      name: filter,
      values: []
    }));

    setFilter?.(filterValues);
  }

  return (
    <IconButton
      size='small'
      iconColor='subtle'
      aria-label={ariaLabelText}
      sx={{ svg: { width: '1.2rem', height: '1.2rem' } }}
      onClick={handleClick}
    >
      <Cross />
    </IconButton>
  );
};
